'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var TableCell = {};

exports.__exports = TableCell;
